import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {cloudLight} from '/theme/color/on.color';
import {getFontFamily} from '/util/text.util';

export const styles = StyleSheet.create({
  base: {},
  header: {
    paddingVertical: indent,
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
  },
  heading: {
    marginBottom: indent * 0.5,
    ...getFontFamily('normal'),
  },
  subheading: {
    paddingTop: 40,
  },
  listItem: {
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
  },
  loadingBoxListItemDate: {
    height: 20,
    width: 80,
    marginBottom: 4,
  },
  loadingBoxListStatus: {
    height: 10,
    width: 50,
  },
  loadingBoxCurrentBalance: {
    height: 30,
    width: 90,
  },
  loadingBoxHistoryBalance: {
    height: 20,
    width: 60,
  },
});
